/**
 * PDP color swatch → GTM dataLayer (color_swatch_switch)
 */
(function () {
  'use strict';

  let lastPushAt = 0;

  /** Dawn uses <product-info>; this theme uses [data-pdp-gtm-product-context] on the PDP grid. */
  function getPdpProductContextEl() {
    return document.querySelector('product-info') || document.querySelector('[data-pdp-gtm-product-context]');
  }

  function pushFromLink(link) {
    if (!link) return null;

    const now = Date.now();
    if (now - lastPushAt < 150) return null;
    lastPushAt = now;

    const container =
      link.closest('.color-swatches') ||
      link.closest('.swatches-conatainer') ||
      link.closest('.pdp_color_variant') ||
      link.closest('.swatch-container');

    const productInfo = getPdpProductContextEl();

    const payload = {
      event: 'color_swatch_switch',
      from_product_id:
        (container && container.getAttribute('data-from-product-id')) ||
        (productInfo && productInfo.getAttribute('data-product-id')) ||
        '',
      from_product_handle:
        (container && container.getAttribute('data-from-product-handle')) ||
        (productInfo && productInfo.getAttribute('data-product-handle')) ||
        '',
      from_product_name:
        (container && container.getAttribute('data-from-product-title')) ||
        (productInfo && productInfo.getAttribute('data-product-title')) ||
        '',
      from_product_sku:
        (container && container.getAttribute('data-from-product-sku')) ||
        (productInfo && productInfo.getAttribute('data-product-sku')) ||
        '',
      to_product_id: link.getAttribute('data-product-id') || '',
      to_product_handle: link.getAttribute('data-product-handle') || '',
      to_product_name: link.getAttribute('data-product-title') || '',
      to_product_sku: link.getAttribute('data-product-sku') || '',
      to_product_url: link.getAttribute('data-product-url') || link.href || '',
      position: link.getAttribute('data-swatch-position') || '',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      const serialized = JSON.stringify(payload);
      sessionStorage.setItem('last_color_swatch_gtm', serialized);
      sessionStorage.setItem('pending_color_swatch_gtm', serialized);
    } catch (err) {
      /* ignore */
    }

    return payload;
  }

  /** Re-push on next page so dataLayer.filter() works after navigation (for QA + GTM). */
  function flushPendingColorSwatchToDataLayer() {
    try {
      const raw = sessionStorage.getItem('pending_color_swatch_gtm');
      if (!raw) return null;

      sessionStorage.removeItem('pending_color_swatch_gtm');
      const payload = JSON.parse(raw);
      if (!payload || payload.event !== 'color_swatch_switch') return null;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      return payload;
    } catch (err) {
      return null;
    }
  }

  function navigateToLink(link) {
    const href = link.href;
    if (!href || href.toLowerCase().indexOf('javascript') === 0) return;
    setTimeout(() => {
      window.location.assign(href);
    }, 500);
  }

  window.onColorSwatchGtmClick = function (event, link) {
    if (!link) return true;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    pushFromLink(link);
    navigateToLink(link);
    return false;
  };

  window.pushColorSwatchGtm = pushFromLink;
  window.handleColorSwatchGtm = pushFromLink;

  window.getLastColorSwatchEvent = function () {
    const layer = window.dataLayer || [];
    for (let i = layer.length - 1; i >= 0; i -= 1) {
      if (layer[i] && layer[i].event === 'color_swatch_switch') {
        return layer[i];
      }
    }
    try {
      return JSON.parse(sessionStorage.getItem('last_color_swatch_gtm'));
    } catch (err) {
      return null;
    }
  };

  /* Pointer travel below this is a tap (open the product). Past it, the row may scroll. */
  const SWATCH_CLICK_SLOP = 40;
  /* Short drags follow the finger but must not free-mode fling across the row. */
  const SWATCH_MOMENTUM_SLOP = 80;

  let pdpSwatchGesture = null;
  let pdpSwatchClickHandled = false;

  function swatchHrefIsNavigable(link) {
    if (!link) return false;
    const href = link.getAttribute('href') || '';
    return href !== '' && href.toLowerCase().indexOf('javascript') !== 0;
  }

  function holdSwatchSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;
    swiper.__swatchAllowTouchMove = swiper.allowTouchMove !== false;
    swiper.allowTouchMove = false;
  }

  function restoreSwatchSwiperMove(swiper) {
    if (!swiper || swiper.destroyed) return;
    swiper.allowTouchMove = swiper.__swatchAllowTouchMove !== false;
  }

  function releaseSwatchSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;
    const data = swiper.touchEventsData;
    if (data) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      data.allowThresholdMove = false;
      data.allowMomentumBounce = false;
      if (data.velocities) data.velocities.length = 0;
    }
    swiper.velocity = 0;
    swiper.allowClick = true;
    if (swiper.touches) swiper.touches.diff = 0;
    restoreSwatchSwiperMove(swiper);
  }

  function markSwatchClickHandled() {
    pdpSwatchClickHandled = true;
    window.setTimeout(() => {
      pdpSwatchClickHandled = false;
    }, 450);
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      const slide = event.target.closest && event.target.closest('.pdp-color-swatch-swiper .swiper-slide');
      if (!slide) return;
      const link = slide.querySelector('a');
      if (!link) return;
      const swiperEl = link.closest('.pdp-color-swatch-swiper');
      const swiperInst = swiperEl && swiperEl.swiper;
      holdSwatchSwiper(swiperInst);
      pdpSwatchGesture = {
        link,
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        maxX: 0,
        maxY: 0,
        dragUnlocked: false,
        swiper: swiperInst || null,
      };
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!pdpSwatchGesture || event.pointerId !== pdpSwatchGesture.pointerId) return;
      const absX = Math.abs(event.clientX - pdpSwatchGesture.x);
      const absY = Math.abs(event.clientY - pdpSwatchGesture.y);
      if (absX > pdpSwatchGesture.maxX) pdpSwatchGesture.maxX = absX;
      if (absY > pdpSwatchGesture.maxY) pdpSwatchGesture.maxY = absY;
      if (
        !pdpSwatchGesture.dragUnlocked &&
        (pdpSwatchGesture.maxX >= SWATCH_CLICK_SLOP || pdpSwatchGesture.maxY >= SWATCH_CLICK_SLOP)
      ) {
        pdpSwatchGesture.dragUnlocked = true;
        restoreSwatchSwiperMove(pdpSwatchGesture.swiper);
      }
    },
    { capture: true, passive: true }
  );

  function endPdpSwatchGesture(event) {
    if (!pdpSwatchGesture || event.pointerId !== pdpSwatchGesture.pointerId) return;
    const gesture = pdpSwatchGesture;
    pdpSwatchGesture = null;

    const absX = gesture.maxX || 0;
    const absY = gesture.maxY || 0;
    const verticalScroll = absY > 12 && absY > absX;
    if (verticalScroll) {
      releaseSwatchSwiper(gesture.swiper);
      markSwatchClickHandled();
      return;
    }

    const link = gesture.link;
    if (absX < SWATCH_CLICK_SLOP && absY < SWATCH_CLICK_SLOP) {
      releaseSwatchSwiper(gesture.swiper);
      if (!swatchHrefIsNavigable(link)) return;
      markSwatchClickHandled();
      window.onColorSwatchGtmClick(null, link);
      return;
    }

    if (absX < SWATCH_MOMENTUM_SLOP) {
      releaseSwatchSwiper(gesture.swiper);
      markSwatchClickHandled();
      return;
    }
    restoreSwatchSwiperMove(gesture.swiper);
    markSwatchClickHandled();
  }

  document.addEventListener('pointerup', endPdpSwatchGesture, { capture: true, passive: true });
  document.addEventListener(
    'pointercancel',
    (event) => {
      if (!pdpSwatchGesture || event.pointerId !== pdpSwatchGesture.pointerId) return;
      releaseSwatchSwiper(pdpSwatchGesture.swiper);
      pdpSwatchGesture = null;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[data-gtm-color-swatch]');
      if (!link) return;
      if (pdpSwatchClickHandled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      window.onColorSwatchGtmClick(event, link);
    },
    true
  );

  flushPendingColorSwatchToDataLayer();
})();
